import { drawing } from '@progress/kendo-drawing';
import { VisualBase } from './VisualBase.js';
import { defined } from '../utils/functions.js';
import { AutoSizeableMixin } from './AutoSizeableMixin.js';
import { MarkerPathMixin } from './MarkerPathMixin.js';
import { deepExtend } from '../utils/deep-extend.js';

class Path extends VisualBase {
    constructor(options) {
        options = deepExtend({ autoSize: true }, options);
        super(options);
        this._capMap = MarkerPathMixin._capMap;
        this.container = new drawing.Group();
        this._setScale = AutoSizeableMixin._setScale.bind(this);
        this._setTranslate = AutoSizeableMixin._setTranslate.bind(this);
        this._initSize = AutoSizeableMixin._initSize.bind(this);
        this._updateSize = AutoSizeableMixin._updateSize.bind(this);
        this._getPath = MarkerPathMixin._getPath.bind(this);
        this._normalizeMarkerOptions = MarkerPathMixin._normalizeMarkerOptions.bind(this);
        this._removeMarker = MarkerPathMixin._removeMarker.bind(this);
        this._createMarkers = MarkerPathMixin._createMarkers.bind(this);
        this._createMarker = MarkerPathMixin._createMarker.bind(this);
        this._positionMarker = MarkerPathMixin._positionMarker.bind(this);
        this._redrawMarker = MarkerPathMixin._redrawMarker.bind(this);
        this._redrawMarkers = MarkerPathMixin._redrawMarkers.bind(this);
        this._createElements();
        this._initSize();
    }
    drawingContainer() {
        return this.container;
    }
    data(value) {
        const options = this.options;
        if (value) {
            if (options.data !== value) {
                options.data = value;
                this._setData(value);
                this._initSize();
                this._redrawMarkers(true, {});
            }
        }
        else {
            return options.data;
        }
    }
    redraw(options) {
        if (options) {
            super.redraw(options);
            const pathOptions = this.options;
            const data = options.data;
            if (defined(data) && pathOptions.data !== data) {
                pathOptions.data = data;
                this._setData(data);
                if (!this._updateSize(options)) {
                    this._initSize();
                }
                this._redrawMarkers(true, options);
            }
            else {
                this._updateSize(options);
                this._redrawMarkers(false, options);
            }
        }
    }
    _createElements() {
        const options = this.options;
        this.drawingElement = drawing.Path.parse(options.data || '', {
            stroke: options.stroke
        });
        this._fill();
        this.container.append(this.drawingElement);
        this._createMarkers();
    }
    _setData(data) {
        const drawingElement = this.drawingElement;
        const multipath = drawing.Path.parse(data || '');
        const paths = multipath.paths.slice(0);
        multipath.paths.elements([]);
        drawingElement.paths.elements(paths);
    }
}

export { Path };
